import {
    RECEIVE_SEGMENTS_DATA,
    REQUEST_SEGMENTS_DATA,
    UPDATE_SEGMENT_DATA,
    DELETE_SEGMENT_DATA,
    TOGGLE_DELETE_SEGMENT_GROUP_MODAL,
    TOGGLE_RENAME_SEGMENT_GROUP_MODAL,
} from "app/action_types/conversion_module_action_types";
import { ConversionSegmentsService } from "app/services/conversion/ConversionSegmentsService";

export const toggleDeleteSegmentModal = (isOpen: boolean, gid: string) => {
    return {
        type: TOGGLE_DELETE_SEGMENT_GROUP_MODAL,
        isOpen,
        gid,
    };
};

export const toggleRenameSegmentModal = (isOpen: boolean, gid: string) => {
    return {
        type: TOGGLE_RENAME_SEGMENT_GROUP_MODAL,
        isOpen,
        gid,
    };
};

export const requestSegments = () => {
    return {
        type: REQUEST_SEGMENTS_DATA,
        segmentsLoading: true,
    };
};

export const receiveSegments = (segments: FixmeType) => {
    return {
        type: RECEIVE_SEGMENTS_DATA,
        segments,
        segmentsLoading: false,
    };
};

export const updateSegmentData = (isNew: boolean, segment: FixmeType) => {
    return {
        type: UPDATE_SEGMENT_DATA,
        segment,
        isNew,
    };
};

export const deleteSegmentData = (groupId: string) => {
    return {
        type: DELETE_SEGMENT_DATA,
        id: groupId,
    };
};

const fetchSegmentsdata = () => {
    return (dispatch: FixmeType, getState: FixmeType) => {
        if (getState().conversionModule.segmentsLoading) {
            return;
        }

        dispatch(requestSegments());

        return ConversionSegmentsService.getInstance()
            .getAllSegmentsData()
            .then((segments) => {
                dispatch(receiveSegments(segments));
            })
            .catch((error) => {});
    };
};
